export default "__VITE_ASSET__3e5c4d45__"